<div class="ladder">
    <img [src]="ladder.svg"/>
</div>
